import { useTheme } from '@mui/material'

interface IDeleteIconProps {
  className?: string
  color?: string
}

const DeleteIcon = ({ className, color }: IDeleteIconProps) => {
  const theme = useTheme()

  return (
    <svg className={className} viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22.5" cy="22.5" r="22.5" fill={color || theme.palette.custom.primary} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.7734 15.3206C30.8453 15.2488 30.9022 15.1635 30.9411 15.0697C30.98 14.9758 31 14.8752 31 14.7736C31 14.672 30.98 14.5714 30.9411 14.4776C30.9022 14.3837 30.8453 14.2984 30.7734 14.2266C30.7016 14.1547 30.6163 14.0978 30.5224 14.0589C30.4286 14.02 30.328 14 30.2264 14C30.1248 14 30.0242 14.02 29.9303 14.0589C29.8365 14.0978 29.7512 14.1547 29.6794 14.2266L22.5 21.4075L15.3206 14.2266C15.2488 14.1547 15.1635 14.0978 15.0697 14.0589C14.9758 14.02 14.8752 14 14.7736 14C14.672 14 14.5714 14.02 14.4776 14.0589C14.3837 14.0978 14.2984 14.1547 14.2266 14.2266C14.1547 14.2984 14.0978 14.3837 14.0589 14.4776C14.02 14.5714 14 14.672 14 14.7736C14 14.8752 14.02 14.9758 14.0589 15.0697C14.0978 15.1635 14.1547 15.2488 14.2266 15.3206L21.4075 22.5L14.2266 29.6794C14.0815 29.8244 14 30.0212 14 30.2264C14 30.4316 14.0815 30.6283 14.2266 30.7734C14.3717 30.9185 14.5684 31 14.7736 31C14.9788 31 15.1756 30.9185 15.3206 30.7734L22.5 23.5925L29.6794 30.7734C29.8244 30.9185 30.0212 31 30.2264 31C30.4316 31 30.6283 30.9185 30.7734 30.7734C30.9185 30.6283 31 30.4316 31 30.2264C31 30.0212 30.9185 29.8244 30.7734 29.6794L23.5925 22.5L30.7734 15.3206Z"
        fill="white"
      />
    </svg>
  )
}

export default DeleteIcon
